import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const Evening = (props) => {
  const { color, ...rest } = props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon viewBox="0 0 20 20" {...rest}>
      <path
        d="M10 4.167V2.5M1.667 10.833h1.666M4.167 5L5 5.833M15.833 5L15 5.833M18.45 10.833h-1.783M10 16.667V12.5M8.333 15L10 16.667 11.667 15M6.667 10.833a3.333 3.333 0 0 1 6.666 0"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

Evening.propTypes = {
  color: PropTypes.string
};

Evening.defaultProps = {
  color: 'var(--color-text-primary)'
};

export default Evening;
